module.exports = ".menu {\n    padding: 8px;\n}\n\n.input-container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin-bottom: 8px;\n}\n\n.input-label {\n    margin-bottom: 0;\n}\n\n.input-container > input {\n    width: 20em;\n    margin-left: 8px;\n}\n\n.btn-container {\n    float: right;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/silk/toolbars/standard-toolbar/link-create/link-create.component.css
// module id = ./src/app/shared/components/silk/toolbars/standard-toolbar/link-create/link-create.component.css
// module chunks = main